"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader as Loader2, Send } from 'lucide-react';
export default function ConnectWithOurLeaders() {
  return <section data-section-id="18772" id="inicia-tu-tramite" className="bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      <script type="application/ld+json">
        {JSON.stringify({
        "@context": "https://schema.org",
        "@type": ["ContactPage", "LocalBusiness", "WebPage"],
        "name": "Contacto - Papeles Sin Miedo",
        "description": "Inicia tu consulta para trámites de apostillas y documentos mexicanos.",
        "url": "https://papelessinmiedo.com/#inicia-tu-tramite",
        "keywords": "apostilla mexicana, apostilla de documentos, acta de nacimiento apostillada, antecedentes no penales apostillados, trámites para mexicanos en el extranjero"
      })}
      </script>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_50%),radial-gradient(ellipse_at_bottom,_var(--color-accent)_0%,_transparent_50%)] opacity-10 pointer-events-none" />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom_right,_var(--color-background)_0%,_var(--color-primary)_100%)] opacity-5 -z-10" />
      
      <div className="absolute top-1/4 left-1/4 h-64 w-64 rounded-lg bg-primary/10 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 h-64 w-64 rounded-lg bg-secondary/5 blur-[100px] pointer-events-none" />

      <div className="container relative mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <h2 className="text-4xl font-sans font-bold tracking-tight sm:text-5xl mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/70">Inicia tu Consulta</h2>
          <p className="text-muted-foreground text-lg font-sans">
            Compártenos tu caso y te orientamos sobre requisitos, tiempos estimados y el siguiente paso para gestionar tu documento desde México.
          </p>
        </div>

        <div className="mx-auto max-w-xl bg-card backdrop-blur-sm border border-border rounded-xl p-6 sm:p-10 shadow-xl ring-1 ring-black/5">
          <FormProvider formId="quick_contact_form_inicio" sectionName="cta" defaultValues={{
          full_name: "",
          email: "",
          phone_country_prefix: "",
          phone: "",
          service_interest: ""
        }} validationRules={{
          full_name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone_country_prefix: {
            required: false
          },
          phone: {
            required: true
          },
          service_interest: {
            required: true
          }
        }} submitText="Enviar Consulta" successMessage="Tu consulta ha sido enviada. Nos pondremos en contacto pronto." errorMessage="Hubo un problema al enviar su consulta. Por favor, intente nuevamente.">
            <ConnectForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function ConnectForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const countryPrefixOptions = ["MX +52", "ES +34", "US +1", "CA +1", "GB +44", "AR +54", "BR +55", "CL +56", "CO +57", "DE +49", "FR +33", "IT +39", "JP +81", "KR +82", "NL +31", "PE +51", "PT +351", "RU +7", "SA +966", "SE +46", "TR +90", "AU +61", "NZ +64", "Otros"];
  const serviceOptions = ["Acta mexicana - ya la tengo para apostilla", "Acta mexicana - aún no la tengo para apostilla", "Antecedentes no penales mexicanos - ya los tengo para apostilla", "Antecedentes no penales mexicanos - aún no los tengo para apostilla", "Título o documento académico mexicano - ya lo tengo para apostilla", "Título o documento académico mexicano - aún no lo tengo para apostilla", "Poder o documento notarial mexicano - ya lo tengo para apostilla", "Poder o documento notarial mexicano - aún no lo tengo para apostilla", "Otro documento mexicano - ya lo tengo para apostilla", "Otro documento mexicano - aún no lo tengo para apostilla"];
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-10 text-center space-y-4 animate-in fade-in zoom-in duration-300">
        <div className="rounded-lg bg-primary/20 p-4 ring-1 ring-primary/50">
          <Send className="h-8 w-8 text-primary" />
        </div>
        <h3 className="text-2xl font-sans font-semibold text-foreground">Consulta Recibida</h3>
        <p className="text-muted-foreground max-w-xs mx-auto font-sans">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 border-border hover:bg-accent font-sans">
          Enviar otro mensaje
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6" method="post" action="/contact" data-tracking-id="contact-form">
      <Input type="hidden" name="target_email" value="josueymg@gmail.com" />
      <FormField control={control} name="full_name" rules={{
      required: "Nombre completo es requerido"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/90 font-sans">Nombre completo</FormLabel>
            <FormControl>
              <Input className="h-12" placeholder="Juan Pérez" aria-label="Nombre completo" {...field} />
            </FormControl>
            <FormDescription className="font-sans">
              Ingrese su nombre y apellido.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email es requerido",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email inválido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/90 font-sans">Correo electrónico</FormLabel>
            <FormControl>
              <Input type="email" className="h-12" placeholder="juan@ejemplo.com" aria-label="Correo electrónico" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-12">
        <div className="sm:col-span-3">
          <FormField control={control} name="phone_country_prefix" render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground/90 font-sans">Prefijo</FormLabel>
                <Select onValueChange={field.onChange} value={field.value}>
                  <FormControl>
                    <SelectTrigger className="h-12 w-full font-sans" aria-label="Prefijo de teléfono">
                      <SelectValue placeholder="País" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    {countryPrefixOptions.map((option, i) => <SelectItem key={i} value={option} data-index={i}>
                        {option}
                      </SelectItem>)}
                  </SelectContent>
                </Select>
                <FormMessage />
              </FormItem>} />
        </div>

        <div className="sm:col-span-9">
          <FormField control={control} name="phone" rules={{
          required: "Teléfono es requerido"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground/90 font-sans">Teléfono</FormLabel>
                <FormControl>
                  <Input type="tel" className="h-12" placeholder="55 1234 5678" aria-label="Teléfono" {...field} />
                </FormControl>
                <FormDescription className="font-sans">
                  Sin repetir el prefijo.
                </FormDescription>
                <FormMessage />
              </FormItem>} />
        </div>
      </div>

      <FormField control={control} name="service_interest" rules={{
      required: "Este campo es requerido"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground/90 font-sans">¿Qué documento necesitas y en qué etapa estás?</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger className="h-12 w-full font-sans" aria-label="Interés del servicio">
                  <SelectValue placeholder="Selecciona tu documento y etapa" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {serviceOptions.map((option, i) => <SelectItem key={i} value={option} data-index={i}>
                    {option}
                  </SelectItem>)}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="rounded-md bg-destructive/15 p-3 text-sm text-destructive border border-destructive/20 font-sans">
          {submitError}
        </div>}

      <div className="pt-2">
        <Button type="submit" variant="secondary" disabled={isSubmitting} className="w-full font-sans font-semibold h-12 text-lg hover:shadow-[0_6px_16px_var(--color-secondary)/0.4] transition-all duration-300 rounded-lg">
          {isSubmitting ? <>
              <Loader2 className="mr-2 h-5 w-5 animate-spin" />
              Enviando...
            </> : "Enviar Consulta"}
        </Button>
        <p className="mt-4 text-center text-sm text-muted-foreground font-sans">
          Revisamos tu caso antes de iniciar para orientarte con claridad.
        </p>
      </div>
    </Form>;
}